import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import renderIf from 'render-if';
// import PlanModel from 'components/PlanModel';
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import PropTypes from 'prop-types';
import styles from './List.scss';// to import local scss fle


class List extends Component {
  static propTypes = {
    attributes: PropTypes.shape().isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {
      paymentStatus: false,
    };
  }

  componentWillMount() {
    const payment = window.sessionStorage.getItem('kiro');
    if (payment === 'true') {
      this.setState({ paymentStatus: true });
    }
  }

  render() {
    const renderAlreadyPaidButton = renderIf(this.state.paymentStatus);
    const renderRedirectButton = renderIf(!this.props.attributes.size > 0);
    const renderPaymentButton = renderIf(this.props.attributes.size > 0
        && !this.state.paymentStatus);
    return (
      <div className={cn('row', styles.container)}>
        <div className={cn('col s12', styles.listContainer)}>
          <div className={cn('col s12 m6', styles.benefitContainer)}>
            <span>
              <h6>MONTHLY SUBSCRIPTION</h6>
              <p>
              Premium members get national exposure to every college that matches
                your academics and biometrics. Upgrade today!
            </p>
            </span>
          </div>
          <div className={cn('col s12 m6', styles.buynow)}>
            <div className={cn('col s12 m8', styles.buynowContainer)}>
              <span>
                <a className={styles.priceValue}>MONTHLY PAYMENT OF <br />$14.99</a><br />
              </span>
            </div>
            <div className={cn('col s12 m4', styles.buynowContainer)}>
              <span>
                {renderAlreadyPaidButton(
                  <button>Already Paid!</button>,
                )}
                {renderPaymentButton(
                  <Link to="/checkout?plan=monthlySubscription&once=true">
                    <button>BUY NOW</button>
                  </Link>,
                  )}

                {renderRedirectButton(
                  <Link to="/register">
                    <button>BUY NOW</button>
                  </Link>,
                  )}

              </span>
            </div>
          </div>
        </div>
        {/* <div className={cn('col s12', styles.listContainer)}>
          <div className={cn('col s12 m6', styles.benefitContainer)}>
            <span>
              <h6>$199 LIFETIME MEMBERSHIP</h6>
              <p>
              $199 for a lifetime membership is ideal for young athletes
              getting a jump start on their recruitment.
            </p>
            </span>
          </div>
          <div className={cn('col s12 m6', styles.buynow)}>
            <div className={cn('col s12 m8', styles.buynowContainer)}>
              <span>
                <a className={styles.priceValue}>1 PAYMENT OF $199</a><br />
              </span>
            </div>
            <div className={cn('col s12 m4', styles.buynowContainer)}>
              <span>
                {renderAlreadyPaidButton(
                  <button>Already Paid!</button>,
                  )}
                {renderPaymentButton(
                  <Link to="/checkout?plan=lifetime&once=true">
                    <button>BUY NOW</button>
                  </Link>,
                  )}

                {renderRedirectButton(
                  <Link to="/register">
                    <button>BUY NOW</button>
                  </Link>,
                  )}
              </span>
            </div>
          </div>
        </div> */}
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/PackagesList/List.js